import { render } from "./CaseClustersSidebar.vue?vue&type=template&id=be186518&ts=true"
import script from "./CaseClustersSidebar.vue?vue&type=script&lang=ts"
export * from "./CaseClustersSidebar.vue?vue&type=script&lang=ts"

import "./CaseClustersSidebar.vue?vue&type=style&index=0&id=be186518&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__